<template>
    <div class="dialog-text">
        <p v-for="key in textLangKeysArray"
           :key="key">
            {{ l(key) }}
        </p>

        <p v-for="customText in customTextArray"
           :key="customText">
            {{ customText }}
        </p>

        <div v-if="customHtml"
             v-html="customHtml"></div>
    </div>
</template>

<script>
import { DialogTextPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogTextPropsMixin';

/**
 * This component can be used to display the text for a modal
 * that is provided by the ModalTextPropsMixin props.
 */
export default {
    mixins: [
        DialogTextPropsMixin,
    ],

    computed: {
        /**
         * Any lang file keys to display, always returned as an array even if it's only one.
         *
         * @returns {string[]}
         */
        textLangKeysArray() {
            if (!this.textLangKeys) {
                return [];
            }

            if (Array.isArray(this.textLangKeys)) {
                return this.textLangKeys;
            }

            return [this.textLangKeys];
        },

        customTextArray() {
            if (!this.customText) {
                return [];
            }

            if (Array.isArray(this.customText)) {
                return this.customText;
            }

            return [this.customText];
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/mixins";
@import (reference) "../../../../less/variables";

.dialog-text {
    &:not(:empty) {
        // When there is only text in the modal add some spacing around it.
        &:first-child:last-child {
            margin-top: @half-gutter-width;
            margin-bottom: @half-gutter-width;
        }

        // When there is something after the text in the modal add some margin after it.
        &:not(:last-child) {
            margin-bottom: 15px;
        }
    }

    p {
        margin: 0;
        font-size: @font-size-large;
        text-align: center;

        &:not(:first-child) {
            margin-top: @half-gutter-width;
        }
    }

    > div {
        font-size: @font-size-large;
        text-align: center;

        &:not(:first-child) {
            margin-top: @half-gutter-width;
        }

        > p {
            margin-left: 0;
            margin-right: 0;
        }
    }
}

@media (max-width: @mobile-max) {
    .dialog-text {
        padding-top: @gutter-width-mobile;
        padding-bottom: @gutter-width-mobile;

        p {
            margin: @gutter-width-mobile;
            font-size: @font-size-base;
        }
    }
}
</style>
